import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class TimerIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 24 24" >
            <g fill="currentColor">
                <path d="M12,24C5.384,24,0,18.618,0,12C0,5.384,5.384,0,12,0c6.617,0,12,5.384,12,12C24,18.618,18.618,24,12,24z M12,2.443
                    C6.73,2.443,2.443,6.73,2.443,12S6.73,21.558,12,21.558S21.558,17.27,21.558,12S17.27,2.443,12,2.443z"/>
                <path d="M16.31,15.378c-0.182,0-0.369-0.042-0.545-0.129l-4.312-2.156c-0.413-0.208-0.675-0.631-0.675-1.093V5.533
                    c0-0.674,0.547-1.222,1.222-1.222s1.221,0.547,1.221,1.222v5.712l3.636,1.817c0.603,0.302,0.848,1.036,0.547,1.639
                    C17.19,15.13,16.76,15.378,16.31,15.378z"/>
            </g>
        </SvgIcon>;
    }
}
